import React, { Fragment, FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { GQLRootQueryToPostConnectionWhereArgs, usePostsQuery } from '../generated/graphql'
import SvgDivider from '../generated/svg/divider'
import { isNotNullish } from '../utils/type-check'
import { BlogArticleItem } from './blog-article-item'

const Outer = styled.div`
  display: flex;
  flex-direction: column;
`

const ItemContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.5rem 1.5rem;
  max-width: 100%;
  @media (max-width: 40rem){
    grid-template-columns: repeat(1, 1fr);
    gap: 2rem;
  }
`

const DividerContainer = styled.div`
  display: none;
  color: #9a8fbb;
  margin: 0 -2rem;
  @media (max-width: 40rem){
    display: block;
  }
  svg {
    display: block;
    width: 100%;
  }
`
const More = styled(Link)`
  display: block;
  align-self: center;
  margin-top: 3rem;
  text-decoration: underline;
`

type BlogArticleListProps = {
  count: number
  where?: GQLRootQueryToPostConnectionWhereArgs
  where2?: GQLRootQueryToPostConnectionWhereArgs
}
export const BlogArticleList: FunctionComponent<BlogArticleListProps> = ({count, where, where2}) => {
  const postsQuery = usePostsQuery({variables: {first: count, where}})
  const postsQuery2 = usePostsQuery({variables: {first: count, where: where2}, skip: !where2})
  const data = [
    ...(postsQuery.data?.posts?.nodes ?? []),
    ...(postsQuery2.data?.posts?.nodes ?? [])
  ].sort((a, b) => {
    const date1 = new Date(a?.date ?? 0).getTime()
    const date2 = new Date(b?.date ?? 0).getTime()
    return date2 - date1
  }).slice(0, count)
  return <Outer>
    <ItemContainer>
      {
        data.filter(isNotNullish).map((post, i) => {
          return <Fragment key={post.postId}>
            {i > 0 ? <DividerContainer><SvgDivider /></DividerContainer> : null}
            <BlogArticleItem post={post} />
          </Fragment>
        })
      }
    </ItemContainer>
    <More to="/blog">一覧を見る</More>
  </Outer>
}